import React from 'react';
import {Collapse, Input, Button, Form, message} from 'antd';

const {Panel} = Collapse;
const {TextArea} = Input;

const Index = () => {

    const [form] = Form.useForm();

    const handleSubmit = (values) => {
        console.log('Yardım Talebi Gönderildi:', values);
        message.success('Yardım talebiniz başarıyla gönderildi!');
        form.resetFields();
    };

    return (
        <>
            <h3>Yardım Sayfası</h3>
            <Collapse accordion>
                <Panel header="1. Yönetici Ekranı Nedir?" key="1">
                    <p>
                        Yönetici ekranı, genel filo sağlığı hakkında bilgi vermektedir. Araç marka, model, yakıt türü ve
                        gruplandırmaya göre ekrandaki hamburger menüler değişmektedir. Ekranın alt kısmında yer alan
                        grafiklerde ise tüm filo için kat edilen toplam mesafe ve günlük ortalama yakıt tüketimi
                        verileri gösterilmektedir.
                    </p>
                </Panel>
                <Panel header="2. Anlık Rapor Nerede?" key="2">
                    <p>
                        Harita izleme ekranında sol açılır menü üzerinden Excel simgesine basarsanız, anlık olarak tüm
                        araçlar için rapora ulaşabilirsiniz.
                    </p>
                </Panel>
                <Panel header="3. Harita Üzerindeki Renklerin Anlamları Nelerdir?" key="3">
                    <p>
                        Harita üzerinde, ilgili araç için halka halka içe geçmiş iki halka bulunmaktadır. En dıştaki
                        halka, aracın arıza durum bilgisini vermektedir:
                    </p>
                    <ul>
                        <li>Kırmızı: Arıza var.</li>
                        <li>Sarı: Araçta bir uyarı var.</li>
                        <li>Yeşil: Araçtan bir arıza ya da uyarı gelmemektedir.</li>
                        <li>Gri: Arıza, uyarı ya da hata bilgisi bulunmamaktadır.</li>
                        <li>Siyah: Bu araçtan daha önce arıza bilgisi alınmamış.</li>
                    </ul>
                    <p>
                        İçerideki halkanın renk anlamları, hareket durumunu belirtmektedir:
                    </p>
                    <ul>
                        <li>Mavi: Araç hareket halinde.</li>
                        <li>Sarı: Araç rölantide.</li>
                        <li>Gri: Araç park durumunda.</li>
                        <li>Kırmızı: Araç durma halinde.</li>
                    </ul>
                </Panel>
                <Panel header="4. Araç ile İlgili Detaylara Nasıl Ulaşabilirim?" key="4">
                    <p>
                        Araç ile ilgili detaylara;
                        <ul>
                            <li>Harita üzerinde tıkladığınızda açılan sağ bardan</li>
                            <li>Liste izleme ekranında ilgili araca tıkladığınızda ulaşabilirsiniz.</li>
                        </ul>
                    </p>
                </Panel>
                <Panel header="5. Sisteme Araç Nasıl Eklenir?" key="5">
                    <p>
                        Ayarlar sekmesi üzerinden Araçlar bölümüne tıklıyoruz. Açılan ekranda Yeni Araç Ekle butonuna
                        basıyoruz. Bu ekran içerisinde ilgili araç bilgilerini doldurup, sisteme ekleme yapabilirsiniz.
                        Takılan cihazın ID'si ile cihaz seçiniz ekranında listelenen cihaz ID'sinin birbiriyle
                        eşleşmesine mutlaka dikkat edilmelidir.
                    </p>
                </Panel>
                <Panel header="6. Seyir Halinde, Durma, Rölanti, Park Ne Demek?" key="6">
                    <p>
                        Aracın durumlarını belirtmektedir:
                    </p>
                    <ul>
                        <li>Kontak açık, motor açık, fren açık: Rölanti durumundadır.</li>
                        <li>Kontak açık, motor açık, fren kapalı: Seyir halindedir.</li>
                        <li>Kontak açık, motor kapalı, fren açık: Durma durumundadır.</li>
                        <li>Kontak kapalı, motor kapalı, fren açık/kapalı: Park durumundadır.</li>
                    </ul>
                </Panel>
                <Panel header="7. Canbus Dashboard Nedir, Nasıl Kullanılır?" key="7">
                    <p>
                        Canbus Dashboard içerisinde 2 sayfa bulunmaktadır:
                    </p>
                    <ul>
                        <li>Araçlar hakkında uyarı veren araçlar</li>
                        <li>Araçlar hakkında arıza veren araçlar</li>
                    </ul>
                    <p>
                        Bu arayüzde, imleci ilgili ikon üzerine getirdiğinizde araç plakası ve kapı numaraları
                        listelenecektir. İlgili ikonun sağ üst tarafında yer alan Excel Raporu butonu ile ikonun uyarı
                        veya arıza bilgilerine göre Excel raporu alabilirsiniz. Tüm uyarı ya da arıza bilgilerinin yer
                        aldığı raporu ise ekranın sağ üst köşesindeki Raporla butonundan alabilirsiniz.
                    </p>
                </Panel>
                <Panel header="8. Harita Üzerinde Online / Offline Araç Seçebilir Miyim?" key="8">
                    <p>
                        Evet, seçilebilir. Harita izleme ekranında sol açılır pencere üzerine tıklanılır. Açılan
                        pencerede çevrimiçi durumuna göre filtrele seçeneklerinden online veya offline araçları
                        filtreleyerek seçebilirsiniz.
                    </p>
                </Panel>
                <Panel header="9. Bildirim Almak İstiyorum, Nasıl Bildirim Ekleyebilirim?" key="9">
                    <p>
                        Ayarlar sekmesi üzerinden Genel Ayarlar seçeneğine tıklıyoruz. Daha sonra Bildirim İşlemleri
                        seçeneğini seçiyoruz. Açılan ekranda Yeni Bildirim Ekle butonuna tıklıyoruz. Bu alandaki ilgili
                        bilgileri doldurduktan sonra bildirim eklenmiş olacaktır.
                    </p>
                    <p>
                        Sistem üzerinde 2 tip bildirim seçeneği bulunmaktadır:
                    </p>
                    <ul>
                        <li>Web Bildirim</li>
                        <li>Mail Bildirim</li>
                    </ul>
                </Panel>
                <Panel header="10. Alarm Özet Raporu Nasıl Kullanılır?" key="10">
                    <p>
                        Araç ve tarih aralığı belirlendikten sonra rapor oluştur butonuna tıklanılır. Sonuçlar ekranında
                        seçilen araçlarla ilgili detaylar listelenecektir. Bu listede ilgili arıza tipleri, arızanın
                        oluşma tarihi ve oluştuğu kilometre sonuçlar ekranında listelenecektir. Konum kolonunda haritada
                        gör butonuna tıklandığında alarmın gerçekleştiği konum popup olarak açılacaktır. Dilerseniz bu
                        raporu Excel veya PDF formatında indirebilirsiniz.
                    </p>
                </Panel>
                <Panel header="11. Geçmiş İzleme Nasıl Kullanılır?" key="11">
                    <p>
                        Harita izleme ekranında ilgili araca sağ tıklanılır. Açılan pencerede araç geçmişi seçilir. Bu
                        ekranda son bir, üç ve beş saatlik periyotlar olacak şekilde filtreleme yapılabilir. Zaman
                        filtresi seçiminden sonra aracın geçmiş bilgileri listelenir.
                    </p>
                </Panel>
                <Panel header="12. Bildirim İletim Sistemi Nasıl Çalışmaktadır?" key="12">
                    <p>
                        Örnek olarak, araç motor hızı parametresini seçtiğimizi düşünelim. Bildirim için bir eşik değeri
                        belirlenmelidir. Örneğin, eşik değerini 50 olarak belirledik. Eğer araç, 50 kilometrenin üzerine
                        çıkarsa sistem, seçtiğimiz bildirim türüne göre bildirim gönderecektir.
                    </p>
                </Panel>
                <Panel header="13. Raporlara Nerede Ulaşabilirim?" key="13">
                    <p>
                        Sol üst barda Raporlar sekmesine imleci getirdiğinizde, rapor türlerine ulaşabilirsiniz.
                    </p>
                </Panel>
                <Panel header="14. Rapor Türleri Hangi Bilgileri Sağlamaktadır?" key="14">
                    <ul>
                        <li>Canbus Raporu: Araç hakkında telemetri cihazından alınan kapsamlı bilgileri içerir.</li>
                        <li>Canbus Özet: Canbus Raporu’nun daha özelleştirilebilir versiyonudur.</li>
                        <li>Yakıt Tüketim Raporu: Belirli zaman aralıklarında aracın yakıt ekonomisi ile ilgili veriler
                            sunar.
                        </li>
                        <li>Alarm Raporu: Araçtan gelen uyarı ve arıza durum bilgilerini içerir.</li>
                        <li>Kontak Mesafe Raporu: Araç rölanti, hız ve fren durumlarına göre analiz edilen rapor
                            türüdür.
                        </li>
                    </ul>
                </Panel>
            </Collapse>
            <div style={{marginTop: '40px'}}>
                <h3>Yardım Talebi</h3>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    style={{maxWidth: '600px', margin: '0 auto'}}
                >
                    <Form.Item
                        label="Başlık"
                        name="title"
                        rules={[
                            {required: true, message: 'Başlık alanı zorunludur!'},
                        ]}
                    >
                        <Input placeholder="Yardım talebi başlığını giriniz..."/>
                    </Form.Item>
                    <Form.Item
                        label="Açıklama"
                        name="description"
                        rules={[
                            {required: true, message: 'Açıklama alanı zorunludur!'},
                        ]}
                    >
                        <TextArea
                            rows={4}
                            placeholder="Yardım talebinizle ilgili detayları buraya yazınız..."
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button disabled={true} type="primary" htmlType="submit" block>
                            Talebi Gönder
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </>
    );
};

export default Index;